import React from 'react';
import { NavLink } from 'react-router-dom';


class Menu extends React.Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}

	// Remove current class from all but clicked, close mobile menu if open.
	handleClick(e) {
		const body = document.querySelectorAll('body')[0];
		const header = document.querySelectorAll('.siteHeader')[0];

		header.setAttribute('data-expanded', 'false');
		body.classList.remove('js-noScroll');
	}

	render(){
		return (
			<ul className="menu" id="primary-menu">
				<li>
					<NavLink exact to="/work/logos/" className={this.props.pathname.match('^/work/(?!project)') ? 'active' : ''} onClick={(e)=>{this.handleClick(e)}}>Work</NavLink>
				</li>
				<li>
					<NavLink exact to="/new/" onClick={(e)=>{this.handleClick(e)}}>New</NavLink>
				</li>
				<li>
					<NavLink exact to="/about/" onClick={(e)=>{this.handleClick(e)}}>About</NavLink>
				</li>
				<li>
					<NavLink exact to="/contact/" onClick={(e)=>{this.handleClick(e)}}>Contact</NavLink>
				</li>
			</ul>
		)
	}
}

export default Menu;


/** WEBPACK FOOTER **
 ** ./src/components/Menu.js
 **/